import React from "react";
import OrderOverViewTable from "./OrderOverViewTable";
import { Panel } from "@/components";
import SyncAllShopOrderButton from "@/components/SyncAllShopOrderButton";
import { collectEvent } from "@/services/dataTrack";
import { useShopInfoStore } from "../store";
import { observer } from "mobx-react-lite";
import DataTrackEvent from "@/services/dataTrack/enum/DataTrackEvent";

interface OverviewCardProps {
    isSupplier?: boolean;
}

/**
 * 店铺概况卡片
 */
const OverviewCard: React.FC<OverviewCardProps> = function (props) {
    const { isSupplier } = props;

    const store = useShopInfoStore();

    return (
        <Panel
            title={
                <div className="flex justify-between">
                    <span>店铺详细数据</span>

                    {!isSupplier ? (
                        <SyncAllShopOrderButton
                            disabled={store.getShopOverviewLoading}
                            onDone={store.reloadShopOverview}
                            onClick={() => {
                                collectEvent(DataTrackEvent.CLICK_HOME_CONTENT, {
                                    content: "同步全部店铺订单",
                                });
                            }}
                        />
                    ) : null}
                </div>
            }
            className="mb10"
        >
            <OrderOverViewTable isSupplier={isSupplier} />
        </Panel>
    );
};

export default observer(OverviewCard);
